import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100 h-100" }
const _hoisted_2 = { style: {"margin-left":"1%"} }
const _hoisted_3 = {
  id: "mydiv",
  class: "main-div-userinquiry-userId"
}
const _hoisted_4 = { class: "search-div margin-top-20" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "search-left-div" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "adjusting-position fs-5" }, "User ID:")
], -1 /* HOISTED */)
const _hoisted_6 = { class: "search-right-div" }
const _hoisted_7 = { class: "search-div" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "search-left-div" }, null, -1 /* HOISTED */)
const _hoisted_9 = { class: "search-right-div" }
const _hoisted_10 = { class: "col-sm-7 errmsg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Alert"], {
        alertMessage: $setup.alertMessage,
        alertState: $setup.alertState
      }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
    ]),
    _createVNode($setup["UserNavigation"], { menuTile: $setup.title }, null, 8 /* PROPS */, ["menuTile"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            class: "txtSearch",
            id: "txtSearch",
            maxlength: "10",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchValue) = $event))
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, $setup.searchValue]
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btnGo",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goSearch()))
          }, " Go ")
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString($setup.userErr), 1 /* TEXT */)
        ])
      ])
    ])
  ]))
}